//---------------------------------
// create new character rune entry
//---------------------------------
export default function createNewCharacterRuneEntry({
  id, // temp id used for tracking
  static_rune,
  strength,
  pwr_storage,
  starter,
  already_integrated,
  integrated,
  active,
  short_powers,
  powers,
  trait,
  character_item,
  item_name,
  character = null,
  display_name = null,
} = {}) {
  console.log('-----------------------')
  console.log('IN createNewCharacterRuneEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }
  //------------------
  // define structure
  //------------------
  let rune = {
    rune: static_rune.id,
    // only include character id for new rune
    ...(character ? { character: character_id } : {}),

    // from static rune
    name: static_rune.name,
    // optional per-instance label; when provided, this allows
    // multiple CharacterRune rows sharing the same base rune
    // name to be distinguished in the UI (e.g. "Air Rune 2").
    ...(display_name ? { display_name } : {}),

    // improvements (from runeCard)
    id: id, // temp id used for tracking
    strength: strength,
    pwr_storage: pwr_storage,
    starter: starter,
    already_integrated: already_integrated,
    integrated: integrated,
    active: active,
    short_powers: short_powers,
    powers: powers,
    trait: trait,
    character_item: character_item,
    item_name: item_name,
  }
  return rune
}
